module.exports = __webpack_public_path__ + "static/media/gokhantelkenar.77eeb8ca.jpg";